import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store.js'
import _ from 'lodash'
// Import routes
import CoreRoutes from '@/routes/core.route'

Vue.use(VueRouter)

var allRoutes = []
allRoutes = allRoutes.concat(CoreRoutes)

const routes = allRoutes

let router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters.isLoggedIn) {
            next('/login')
        } else {
            let user = JSON.parse(localStorage.getItem('user'))
            const { authorize } = to.meta
            if (_.includes(authorize, user.role.toUpperCase())) {
                next()
            } else {
                next('/')
            }
        }
    } else {
        next()
    }
})

export default router
